import React from 'react';
import { bookingClientViewModel } from '../../view-model/client/client-booking-view-model';
import { observer } from 'mobx-react-lite';

interface SalonPhotosProps {
  mainPhoto?: string;
  secondaryPhotos?: string[];
}

const SalonPhotos: React.FC<SalonPhotosProps> = observer(({ mainPhoto: propMainPhoto, secondaryPhotos: propSecondaryPhotos = [] }) => {
  // Utiliser les photos de galerie du view-model si disponibles, sinon utiliser les props
  const galleryPhotos = bookingClientViewModel.galleryPhotos || [];
  
  // Si galleryPhotos est disponible, l'utiliser, sinon utiliser les props
  const mainPhoto = galleryPhotos.length > 0 ? galleryPhotos[0] : propMainPhoto;
  const secondaryPhotos = galleryPhotos.length > 1 ? galleryPhotos.slice(1) : propSecondaryPhotos;
  
  // Remplir avec des photos vides si nécessaire pour avoir 4 emplacements
  const filledPhotos: (string | undefined)[] = [...secondaryPhotos.slice(0, 4)];
  while (filledPhotos.length < 4) {
    filledPhotos.push(undefined);
  }

  return (
    <div className="bg-white/80 backdrop-blur-sm rounded-xl shadow-md border border-gray-200 p-3">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {/* Photo principale */}
        <div>
          <div className="aspect-[3/2] bg-gray-100 rounded-lg overflow-hidden">
            {mainPhoto ? (
              <img 
                src={mainPhoto} 
                alt="Photo principale du salon" 
                className="w-full h-full object-cover"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-gray-400">
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
            )}
          </div>
        </div>

        {/* 4 photos secondaires carrées, hauteur égale à principale */}
        <div className="relative aspect-[3/2]">
          <div className="absolute inset-0 grid grid-cols-2 grid-rows-2 gap-2">
            {filledPhotos.map((photo, index) => (
              <div key={index} className="bg-gray-100 rounded-lg overflow-hidden">
                {photo ? (
                  <img 
                    src={photo} 
                    alt={`Photo secondaire ${index + 1}`} 
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-gray-300">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
});

export default SalonPhotos;